import type { LegalPageId } from './pages.ts';

/**
 * Các phiên bản của một văn bản pháp lý.
 *
 * ⚠️ KHÁC bản `main` một chỗ CÓ CHỦ Ý: `main/src/lib/legalVersions.ts` khai
 * `href: { vi: '/vi/terms/', en: '/en/terms/' }` — URL viết TAY. Contract §1.1 cấm đúng điều đó
 * (*"Cấm khai URL ở chỗ thứ hai — kể cả một chuỗi `'/vi/bang-gia'` viết tay trong một
 * component"*), nên port nguyên trạng là chọc vào contract bất biến.
 *
 * Ở đây khai `pageId`, còn URL do `pathFor(pageId, locale)` sinh. Hệ quả: đổi slug trong `PAGES`
 * là bộ chuyển phiên bản tự trỏ đúng, không có chỗ thứ hai để quên cập nhật.
 */
export interface LegalVersion {
  readonly id: string;
  /** dd/mm/yyyy — ĐÓNG BĂNG lúc ban hành, KHÔNG lấy từ config. Bản lưu trữ giữ ngày của nó. */
  readonly effectiveDate: string;
  readonly pageId: LegalPageId;
}

/** Phần tử ĐẦU luôn là bản hiện hành — `VersionSwitcher` và cờ noindex đều dựa vào thứ tự này. */
export const TERMS_VERSIONS: readonly LegalVersion[] = [
  { id: 'v2.2', effectiveDate: '01/07/2026', pageId: 'legal-terms' },
  { id: 'v1', effectiveDate: '05/06/2026', pageId: 'legal-terms-v1' },
] as const;

export const PRIVACY_VERSIONS: readonly LegalVersion[] = [
  { id: 'v2.2', effectiveDate: '01/07/2026', pageId: 'legal-privacy' },
  { id: 'v1', effectiveDate: '05/06/2026', pageId: 'legal-privacy-v1' },
] as const;

/** `docMeta.versions` khai tên bộ dưới dạng chuỗi; đây là chỗ đổi chuỗi đó thành dữ liệu. */
export const VERSION_SETS = {
  terms: TERMS_VERSIONS,
  privacy: PRIVACY_VERSIONS,
} as const;

export type VersionSetName = keyof typeof VERSION_SETS;
